<img [src]="imagePath" [alt]="altText" loading="lazy">
